import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { AlphanumericValidator } from 'src/app/utility/validator/alphanumeric.validator';
import { IndClaimSubmission } from '../../model/ind-claim-submission';
import { IndividualClaimSubmissionService } from '../../service/individual-claim-submission/individual-claim-submission.service';
import { OtpService } from '../../service/otp/otp.service';

@Component({
  selector: 'app-validate-policy-data',
  templateUrl: './validate-policy-data.component.html',
  styleUrls: ['./validate-policy-data.component.scss']
})
export class ValidatePolicyDataComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private individualClaimSubmissionService: IndividualClaimSubmissionService,
    private otpService: OtpService
  ) { }

  @Input() submissionData: IndClaimSubmission;
  @Output() onValidPolicyData: EventEmitter<any> = new EventEmitter();
  @Output() onPrevTab: EventEmitter<any> = new EventEmitter();
  @Output() onNextTab: EventEmitter<any> = new EventEmitter();
  @Output() onOtpSessionCancel: EventEmitter<any> = new EventEmitter();

  isDisabledNext: boolean = true;

  public policyDataForm: FormGroup = this.fb.group({
    policyNumber: [null, [Validators.required, AlphanumericValidator]],
    birthYear: [null, [Validators.required, Validators.pattern(/^[0-9]{4}$/)]]
  });

  ngOnInit() {
    //console.log('ValidatePolicyDataComponent', this.submissionData);
  }

  validatePolicyData(formDirectiveValidatePolicy: FormGroupDirective) {
    let entity = this.policyDataForm.value;
    entity.browserId = this.submissionData.browserId;
    entity.claimSubmitterMobileNumber = this.submissionData.claimSubmitterMobileNumber;
    
    this.individualClaimSubmissionService.validatePolicyData(entity).subscribe(res => {
      //console.log('validatePolicyData', res);
      this.onValidPolicyData.emit(entity);
      this.policyDataForm.disable();
      this.isDisabledNext = false;
    },
      err => {
        this.messageService.show(err.error.message, "error");
      })
  }

  resetFormSettings(){
    this.policyDataForm.enable();
    this.policyDataForm.reset();
  }

  prevTab(){
    this.onPrevTab.emit();
  }

  nextTab(){
    this.onNextTab.emit()
  }

  cancel() {
    this.otpService.otpSessionCancel(this.submissionData.browserId).subscribe(res => {
      const data = {
        isResettable: true
      }
      this.onOtpSessionCancel.emit(data);
    },
    err => {
      this.messageService.show(err.error.message, "error");
    });
  }
}
